import React from "react";
import { NavLink } from "react-router-dom";
import { VISITOR } from "router/router.config";
import { useAuthentication } from "domain/Authentication";
import { FaEye as VisitorIcon } from "react-icons/fa";
import clsx from "clsx";

import "./visitor-view-link.scss";

export const VisitorViewLink = () => {
  const { isPrivileged } = useAuthentication();

  if (!isPrivileged) {
    return null;
  }

  return (
    <div className="visitor-view-link">
      <NavLink to={VISITOR} className={({ isActive }) => clsx("visitor-view-link__link", { active: isActive })}>
        <VisitorIcon className="visitor-view-link__icon" />
        <span className="visitor-view-link__label">Tvoj inventar</span>
      </NavLink>
    </div>
  );
};
